import "./App.css";
export default function ProgressBar({ width }) {
  return (
    <div className="flex justify-center py-2">
      <div className="mt-2 md:mt-4 w-[20rem] md:w-[42rem]">
        <h4 className="sr-only">Status</h4>
        <p className="text-sm font-medium text-gray-900"></p>
        <div className="mt-6" aria-hidden="true">
          <div className="bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-3 bg-gradient-to-r  from-green-primary to-blue-complimentary rounded-full progress transition delay-150 duration-500 ease-in-out"
              style={{ width: width }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
